import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import Table from 'components/Table'
import ExpandablePanel from 'components/ExpandablePanel'
import { fetchPaymentProblems } from 'services/StudentPaymentProblemsService'
import AddPaymentProblemModal from 'modules/students/components/AddPaymentProblemModal'
import DeletePaymentProblemModal from 'modules/students/components/DeletePaymentProblemModal'
import { parseNumber } from 'utils/numbers'

const PaymentProblems = () => {
  const [problems, setProblems] = useState([])

  const fetchProblems = () => {
    fetchPaymentProblems().then(setProblems)
  }

  useEffect(() => {
    fetchProblems()
  }, [])

  return (
    <div>
      <PageHeader>Problemy z wpłatami</PageHeader>
      <ExpandablePanel startOpen title='Lista wpisów do przejrzenia'>
        <Table>
          <thead>
            <tr>
              <th>Lp.</th>
              <th>Data</th>
              <th>Kwota</th>
              <th>Tytuł</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {problems.map((problem, index) => (
              <tr key={problem.id}>
                <td>{index + 1}</td>
                <td>{problem.date}</td>
                <td>{parseNumber(problem.amount).toFixed(2)} zł</td>
                <td>{problem.title}</td>
                <td>
                  <Actions>
                    <AddPaymentProblemModal problem={problem} onSuccess={fetchProblems} />
                    <DeletePaymentProblemModal problem={problem} onSuccess={fetchProblems} />
                  </Actions>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        {problems.length === 0 && (
          <EmptyState>Brak wpisów do przejrzenia</EmptyState>
        )}
      </ExpandablePanel>
    </div>
  )
}

export default PaymentProblems

const PageHeader = styled.div`
  font-size: 24px;
  margin-bottom: 20px;
`

const EmptyState = styled.div`
  padding: 40px;
  text-align: center;
  color: ${({ theme }) => theme.colors.darkGrey || '#666'};
`

const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  width: 100%;
`
